/* global axios */

import ApiClient from './ApiClient';

class TranslationPreferencesAPI extends ApiClient {
  constructor() {
    super('profile/translation_preference', { accountScoped: false });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.patch(this.url, {
      translation_preference: data,
    });
  }
}

export default new TranslationPreferencesAPI();
